export default "__VITE_ASSET__CFmL2MV2__"